import fillY from './fillY'
import formatAgent from './formatAgent'
import formatArticle from './formatArticle'
import formatChange from './formatChange'
import formatDuration from './formatDuration'
import formatEmpty from './formatEmpty'
import formatInteger from './formatInteger'
import formatPercent from './formatPercent'
import formatPercentChange from './formatPercentChange'
import formatPercentTotal from './formatPercentTotal'
import formatRatings from './formatRatings'
import formatRatingsThumbs from './formatRatingsThumbs'
import formatTeams from './formatTeams'

export default function formatDatum(datum = {}, options = {}) {
  const { x, xActual = x } = datum
  const { scale: { y: yScale, formatYAs = yScale } = {} } = options
  const filledY = fillY(datum, options)
  const filledDatum = {
    ...datum,
    filledY,
  }
  if (filledY === null) return formatEmpty(filledDatum, options)
  if (formatYAs === 'agent') return formatAgent(filledDatum, options)
  if (formatYAs === 'article') return formatArticle(filledDatum, options)
  if (formatYAs === 'teams') return formatTeams(filledDatum, options)
  if (formatYAs === 'integer') return formatInteger(filledDatum, options)
  if (formatYAs === 'duration') return formatDuration(filledDatum, options)
  if (formatYAs === 'x') return xActual
  if (formatYAs === 'percent') return formatPercent(filledDatum, options)
  if (formatYAs === 'change') return formatChange(filledDatum, options)
  if (formatYAs === 'ratings') return formatRatings(filledDatum, options)
  if (formatYAs === 'ratings-thumbs')
    return formatRatingsThumbs(filledDatum, options)
  if (formatYAs === 'percent_change')
    return formatPercentChange(filledDatum, options)
  if (formatYAs === 'percent_total')
    return formatPercentTotal(filledDatum, options)
  return filledY
}
